import { IS_E2E } from '@/test-support/e2e-mode';

/**
 * LaunchDarkly client-side configuration, split out of the provider so leaf
 * modules (experiments, kill switches) can ask "is LD on?" without importing
 * the React provider and its auth dependencies.
 *
 * E2E builds force LD off even when `.env` carries a client id: the provider
 * has always documented E2E as a no-op passthrough, and experiments must be
 * deterministic under Playwright (every slot renders control, exposures fire
 * with `is_fallback: true`).
 */
export const LD_CLIENT_SIDE_ID: string | undefined = IS_E2E
  ? undefined
  : (import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID as string | undefined);

/** True when a client-side ID is configured (LDProvider will mount). */
export function isLdConfigured(): boolean {
  return Boolean(LD_CLIENT_SIDE_ID);
}
